import { type FilterConfigRepository } from '../../ports';

export interface DeleteFilterConfigPayload {
  protocolId: string;
  userId: string;
  configId: string;
}

export class DeleteFilterConfigUseCase {
  constructor(private readonly repository: FilterConfigRepository) {}

  async execute(input: Readonly<DeleteFilterConfigPayload>): Promise<void> {
    const { protocolId, userId, configId } = input;

    return this.repository.delete(protocolId, userId, configId);
  }
}
